<template>
  <el-select v-model="id" allow-create filterable :clearable="clearable" :disabled="disabled" :multiple="multiple" placeholder="请选择或输入" :remote-method="remoteMethod" :loading="loading" @change="selectChange">
    <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.name">
      <span>{{ item.name}}</span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: "",
    clearable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      default: 1,
    },
    cache: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      list: [],
      id: "",
      loading: false,
    }
  },
  created() {
    this.id = this.value;
  },
  mounted() {
    this.remoteMethod(this.value);
  },
  watch: {
    value: function (newValue) {
      this.id = newValue;
      this.remoteMethod(this.id);
    },
  },
  destroyed() {
    if (!this.cache) {
      this.func.removeSession("question-tags");
    }
  },
  methods: {
    remoteMethod(query) {
      if (this.func.getSession("question-tags") && this.cache) {
        this.list = this.func.getSession("question-tags");
        return;
      }
      this.loading = true;
      let params = {
        "name": "",
        "pageIndex": 1,
        "pageSize": 100,
        "type": this.type,
      }
      this.list = [];
      this.https("get", "/api/Tag/GetTags", params).then(res => {
        this.loading = false;
        this.list = res.response.data || [];
        this.func.setSession("question-tags", this.list);
      }).catch(res => {
        this.loading = false;
      })
    },
    selectChange(val) {
      this.$emit('input', val);
      if (!this.multiple) {
        let obj = this.list.find(item => val == item.name);
        this.$emit('change', obj);
      } else {
        let list = this.list.filter(item => val.indexOf(item.name) >= 0);
        this.$emit('change', list);
      }
    },
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/QuestionTags.vue